import { Observable } from 'rxjs';
import { User, UserRequest } from '../user/model';
import { Subscription } from '../suscriptions/model'; // Import Subscription model

export abstract class UserOperationsRepository {
  abstract create(user: UserRequest): Observable<User>;
  abstract getById(id: number): Observable<User>;
  abstract getUsers(page: number, limit: number): Observable<User[]>;
  abstract updateById(id: number, user: Partial<User>): Observable<User>;
  abstract delete(id: number): Observable<void>;
  // New methods for subscription operations
  abstract createSubscription(subscription: Partial<Subscription>): Observable<Subscription>;
  abstract updateSubscription(subscription: Partial<Subscription>): Observable<Subscription>;
  abstract getSubscription(id: number): Observable<Subscription>;

  // New methods for document packages
  abstract getDocumentPackages(userId: number, page: number, limit: number): Observable<any>;
  abstract addDocumentPackage(payload: { users_id: number, quantity: number, marketplace_package_id: number }): Observable<any>;
  abstract getAvailablePackages(page: number, limit: number): Observable<any>;

  abstract initializeConfig(userId: number): Observable<any>;
}
